module.exports = __webpack_public_path__ + "img/geofisica2_4-3_682.36eb29fc.jpg";